module.exports = __webpack_public_path__ + "static/media/1POLICY33.312d7d3c.jpg";